export function getAgeType(name) {
  if (name === "ADT") return "adult";
  else if (name === "CNN") return "child";
  else if (name === "INF") return "infant";

  return name;
}

export function getAgeTypeFromLib(name) {
  const traveller = name.toLocaleUpperCase();
  const travellerLib = {
    ADT: "Adult",
    CHD: "Child",
    CNN: "Child",
    INF: "Infant",
    INS: "Infant",
  };
  return travellerLib[traveller];
}
